import React, { useState, useEffect } from "react";
import { BsFillSendFill } from "react-icons/bs";
import './calculator.css'

const CalculatorModal = ({ product_name, onClose, onSave, initialValue = '' }) => {
  
  const [calcValue, setCalcValue] = useState(initialValue);

  // Update the calcValue when initialValue changes (in case the modal opens again)
  useEffect(() => {
    setCalcValue(initialValue);
  }, [initialValue]);

  // Handle saving the result and closing the modal
  const handleSave = () => {
    if (calcValue && !isNaN(calcValue)) {
      onSave(parseFloat(calcValue)); // Save the result to the parent
      onClose(); // Close the modal after saving
    } else {
      alert("Please enter a valid number.");
    }
  };

  // Function to append value to current input
  const handleButtonClick = (value) => {
    setCalcValue((prevValue) => (prevValue || '') + value);
  };

  // Function to handle the calculation result
  const handleEqualClick = () => {
    try {
      // Only allow a safe expression to be evaluated
      const result = eval(calcValue);
      if (!isNaN(result)) {
        setCalcValue(result.toString()); // Set the result as calcValue
      } else {
        alert("Invalid expression.");
        setCalcValue(''); // Clear input on invalid expression
      }
    } catch (e) {
      alert("Invalid expression.");
      setCalcValue(''); // Clear input on invalid expression
    }
  };
  
  // Function to clear the input
  const handleClear = () => {
    setCalcValue('');
  };

  return (
    <div className="">
      <div className="flex">
        <h2 className="text-blue-700 mb-3 text-1xl font-bold text-center pb-2">Calculator</h2>
      </div>
      <div className="modal-content">
        <input
          type="text"
          value={calcValue}
          onChange={(e) => setCalcValue(e.target.value)}
          className="calc-input"
        />
        
        <div className="calculator-buttons">
          <button onClick={() => handleButtonClick('1')}>1</button>
          <button onClick={() => handleButtonClick('2')}>2</button>
          <button onClick={() => handleButtonClick('3')}>3</button>
          <button onClick={() => handleButtonClick('+')}>+</button>
          
          <button onClick={() => handleButtonClick('4')}>4</button>
          <button onClick={() => handleButtonClick('5')}>5</button>
          <button onClick={() => handleButtonClick('6')}>6</button>
          <button onClick={() => handleButtonClick('-')}>-</button>
          
          <button onClick={() => handleButtonClick('7')}>7</button>
          <button onClick={() => handleButtonClick('8')}>8</button>
          <button onClick={() => handleButtonClick('9')}>9</button>
          <button onClick={() => handleButtonClick('*')}>*</button>
          
          <button onClick={() => handleButtonClick('0')}>0</button>
          <button onClick={handleClear}>C</button>
          <button onClick={() => handleButtonClick('.')}>.</button>
          <button onClick={() => handleButtonClick('/')}>/</button>
          
          <button className="equal-button" onClick={handleEqualClick}>=</button>
        </div>

    
      </div>
      <div className="flex justify-end mt-2">
                      <button
                        onClick={handleSave} // Call handleSave to update the parent with the new description
                        className="bg-blue-500 hover:bg-blue-600 text-white py-2 px-6 rounded-md flex items-center space-x-2 shadow-md hover:shadow-lg transition-all duration-200"
                      >
                        <BsFillSendFill className="text-white" />
                        <span>Save</span>
                      </button>
                    </div>
    </div>
  );
};

export default CalculatorModal;
